(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('blocked-time-reason', {
                parent: 'entity',
                url: '/blocked-time-reason',
                data: {
                    authorities: [],
                    pageTitle: 'BlockedTimeReasons'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/blocked-time-reason/blocked-time-reasons.html',
                        controller: 'BlockedTimeReasonController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access);
                }]
            })
            .state('blocked-time-reason.new', {
                parent: 'blocked-time-reason',
                url: '/new',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-dialog.html',
                            controller: 'BlockedTimeReasonDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['CoreService', function (CoreService) {
                                    return {
                                        name: null,
                                        id: null,
                                        facility: CoreService.getCurrentFacility()
                                    };
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('blocked-time-reason');
                        });
                    }
                }]
            })
            .state('blocked-time-reason.edit', {
                parent: 'blocked-time-reason',
                url: '/{id}/edit',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-dialog.html',
                            controller: 'BlockedTimeReasonDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['BlockedTimeReason', function (BlockedTimeReason) {
                                    return BlockedTimeReason.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            })
            .state('blocked-time-reason.delete', {
                parent: 'blocked-time-reason',
                url: '/{id}/delete',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', 'Auth', 'ACTIONS', 'access', function ($stateParams, $state, $uibModal, Auth, ACTIONS, access) {
                    if (Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_BLOCKED_TIME_REASON, access)) {
                        $uibModal.open({
                            templateUrl: 'app/entities/blocked-time-reason/blocked-time-reason-delete-dialog.html',
                            controller: 'BlockedTimeReasonDeleteController',
                            controllerAs: 'vm',
                            size: 'md',
                            windowTopClass: 'custom-dialog-styles',
                            resolve: {
                                entity: ['BlockedTimeReason', function (BlockedTimeReason) {
                                    return BlockedTimeReason.get({id: $stateParams.id}).$promise;
                                }]
                            }
                        }).result.then(function () {
                            $state.go('blocked-time-reason', null, {reload: 'blocked-time-reason'});
                        }, function () {
                            $state.go('^');
                        });
                    }
                }]
            });
    }

})();
